import PropTypes from 'prop-types';

export const GoogleLocationMapShape = PropTypes.objectOf(
  PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
);
